import { Button } from "@/components/ui/button";
import { Copy, X } from "lucide-react";

interface SelectionSectionProps {
  selectedCount: number;
  onCopy: () => void;
  onClear: () => void;
}

export const SelectionSection = ({ selectedCount, onCopy, onClear }: SelectionSectionProps) => (
  <div className="flex items-center gap-2">
    <span className="text-sm font-medium text-gray-300">
      {selectedCount} selected
    </span>
    <div className="h-3.5 w-px bg-gray-700" />
    <Button
      variant="ghost"
      size="sm"
      className="h-7 px-2 text-white hover:bg-gray-800 hover:text-white"
      onClick={onCopy}
    >
      <Copy className="mr-1 h-3.5 w-3.5" />
      Copy
    </Button>
    <Button
      variant="ghost"
      size="sm"
      className="h-7 px-2 text-gray-400 hover:bg-gray-800 hover:text-white"
      onClick={onClear}
    >
      <X className="mr-1 h-3.5 w-3.5" />
      Clear
    </Button>
  </div>
);
